import { createApi } from "@reduxjs/toolkit/query/react";
import { AUTH } from "../../configs";
import {
  LoginData,
  LoginResponse,
  RegisterData,
  RegisterResponse,
} from "../../types";
import { createBaseQuery } from "../helpers/baseQueryHelper";

export type RegisterRequest = Omit<RegisterData, "confirmPassword">;

interface ResetPasswordRequest {
  password: string;
  email: string;
  token: string;
}

const authApi = createApi({
  reducerPath: AUTH.reducerPath,
  baseQuery: createBaseQuery(AUTH.baseUrl),
  tagTypes: AUTH.tagTypes,
  endpoints(builder) {
    return {
      register: builder.mutation<RegisterResponse, RegisterRequest>({
        query: (userData) => ({
          url: "/user/signup",
          method: "POST",
          body: userData,
        }),
      }),
      login: builder.mutation<LoginResponse, LoginData>({
        query: (userData) => ({
          url: "/user/login",
          method: "POST",
          body: userData,
        }),
      }),
      resetPassword: builder.mutation<
        { success: boolean },
        ResetPasswordRequest
      >({
        query: (userData) => ({
          url: "/user/reset-password",
          method: "POST",
          body: userData,
        }),
      }),
    };
  },
});

export const {
  useRegisterMutation,
  useLoginMutation,
  useResetPasswordMutation,
} = authApi;

export { authApi };
